<template>
  <div class="common-bg">
    <div class="tool-drawer-header">
      <a @click="clickBack">
        <a-icon type="left" />
      </a>
      <div class="title">{{$t('edit.injectInfo.addImage')}}</div>
    </div>
    <div class="tool-drawer-content">
      <!-- 標題 -->
      <div class="tit-box" style="padding: 10px 20px">
        <div class="tit-desc">
          <span>{{$t('edit.title')}}</span>
        </div>
        <a-input :placeholder="$t('edit.hpInfo.inputTitle')" v-model="pasterObj.title" />
      </div>
      <div style="padding: 0 20px">
        <material-select :type="1" @selected="handleSelectedImg">
          <template slot="body">
            <a-button type="primary" ghost>{{$t('edit.sandboxs.selectImg2')}}</a-button>
          </template>
        </material-select>
        <div v-show="pasterObj.url" style="margin-top: 10px; display: flex; justify-content: center; align-items: center;max-height: 300px;background-color: rgba(0,0,0,.3)">
          <img style="max-width: 100%; max-height: 300px" :src="pasterObj.url" />
        </div>
      </div>

      <div style="margin: 20px 24px">
        <div style="display: flex; justify-content: space-between">
          <div>{{$t('edit.injectInfo.tinyAdjust')}}</div>
          <a class="edit" @click="resetData">{{$t('actionTitles.reset')}}</a>
        </div>
        <a-row style="margin-top: 10px">
          <a-col :span="4">
            <img
                    style="width: 30px; height: 30px"
                    src="../../assets/img/x-rotate.png"
            />
          </a-col>
          <a-col :span="14">
            <a-slider v-model="pasterObj.rx" :min="-180" :max="180" :step="1" />
          </a-col>
          <a-col :span="6">
            <a-input-number v-model="pasterObj.rx" style="height: 30px; width:auto" />
          </a-col>
        </a-row>
        <a-row style="margin-top: 10px">
          <a-col :span="4">
            <img
                    style="width: 30px; height: 30px"
                    src="../../assets/img/y-rotate.png"
            />
          </a-col>
          <a-col :span="14">
            <a-slider v-model="pasterObj.ry" :min="-180" :max="180" :step="1" />
          </a-col>
          <a-col :span="6">
            <a-input-number v-model="pasterObj.ry" style="height: 30px; width:auto" />
          </a-col>
        </a-row>
        <a-row style="margin-top: 10px">
          <a-col :span="4">
            <img
                    style="width: 30px; height: 30px"
                    src="../../assets/img/z-rotate.png"
            />
          </a-col>
          <a-col :span="14">
            <a-slider v-model="pasterObj.rz" :min="-180" :max="180" :step="1" />
          </a-col>
          <a-col :span="6">
            <a-input-number v-model="pasterObj.rz" style="height: 30px; width:auto" />
          </a-col>
        </a-row>
        <a-row style="margin-top: 10px">
          <a-col :span="4">
            <div class="icon-wrapper">
              <a-icon type="search" style="font-size: 18px; color: #c2c2c2" />
            </div>
          </a-col>
          <a-col :span="14">
            <a-slider
                    v-model="pasterObj.scale"
                    :min="0"
                    :max="1.0"
                    :step="0.01"
                    
            />
          </a-col>
          <a-col :span="6">
            <a-input-number v-model="pasterObj.scale" style="height: 30px; width:auto" />
          </a-col>
        </a-row>
      </div>

      <div style="margin: 10px 24px">
        <span style="line-height: 4">{{$t('edit.injectInfo.positionAdjust')}}</span>
      </div>
      <div class="adjust-container">
        <FineTune @onClickAdjust="onClickAdjust"></FineTune>
      </div>
    </div>

    <div class="tool-drawer-btns">
      <DoubleBtn
              @onClickSave="handleClickSave"
              @onClickCancel="clickDelete"
      ></DoubleBtn>
    </div>
  </div>
</template>

<script>
import MaterialSelect from "@/components/MaterialSelect";
import FineTune from "./FineTune.vue";
import { v4 as uuidv4 } from "uuid";
import DoubleBtn from "../DoubbleBtn";
import { mapGetters } from "vuex";

export default {
  components: { MaterialSelect, FineTune, DoubleBtn },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  data() {
    return {
      pasterObj: {
        type: "pic",
        tite:'',
        paster_id: "paster" + uuidv4(),
        url: "",
        ath: 0,
        atv: 0,
        rx: 0,
        ry: 0,
        rz: 0,
        scale: 0.5,
      },
      originData: {
        rx: 0,
        ry: 0,
        rz: 0,
        scale: 0.5,
      },
    };
  },
  watch: {
    defaultValue: {
      handler: function (value) {
        if (value) {
          this.pasterObj = value;
          //保存原始數據
          const data = { ...value }
          this.originData.ry = data.ry;
          this.originData.rz = data.rz;
          this.originData.scale = data.scale;
          this.originData.rx = data.rx;
        }
      },
      immediate: true,
      deep: true,
    },
    newPasterObj: {
      handler: function (val, oldVal) {
        if (val.ath == "" && val.atv == "") {
          const vh = getSceneViewAt();
          this.pasterObj.ath = vh.hlookat;
          this.pasterObj.atv = vh.vlookat;
        }
        this.$emit("change", this.pasterObj, oldVal);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
    newPasterObj() {
      return this.$deepClone(this.pasterObj);
    },
  },
  mounted() {
    this.$bus.$on("updatePaster", (e) => {
      if (e.paster_id == this.pasterObj.paster_id) {
        this.pasterObj.ath = e.ath;
        this.pasterObj.atv = e.atv;
      }
    });
  },
  methods: {
    clickBack() {
      this.$emit("clickBack", this.pasterObj);
    },
    clickDelete() {
      this.$emit("clickDelete", this.pasterObj);
    },
    handleClickSave() {
      this.$emit("saveDataToStore", {
        key: this.pasterObj.paster_id,
        data: this.pasterObj,
      });
    },
    handleSelectedImg(item) {
      this.pasterObj.url = item.url;
    },
    onClickAdjust(driction) {
      if (this.pasterObj.url === "") {
        this.$message.error(this.$t('edit.editMessage.imageAlert'));
        return;
      }
      if(driction === "left") {
        this.pasterObj.ath -= 1
      }
      if(driction === "right") {
        this.pasterObj.ath += 1
      }
      if(driction === "down") {
        this.pasterObj.atv += 1
      }
      if(driction === "top") {
        this.pasterObj.atv -= 1
      }
    },
    resetData() {
      // console.log("===resetData===", this.pasterObj, this.originData)
      const data = { ...this.originData }
      this.pasterObj.rx = data.rx;
      this.pasterObj.ry = data.ry;
      this.pasterObj.rz = data.rz;
      this.pasterObj.scale = data.scale;
    }
  },
};
</script>